import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Breadcrumb,
  Card,
  CardHeader,
  CardBody,
  Form,
  CardFooter,
} from "react-bootstrap";
import "../../assets/css/brandbook.css";
import { Button } from 'primereact/button';
import { Checkbox } from "primereact/checkbox";
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import { useNavigate } from 'react-router-dom';
import { AutoComplete } from "primereact/autocomplete";
import axios from 'axios';
import config from '../../config';
import CustomToast from '../../components/CustomToast';
import { useAuth } from '../../context/AuthContext';
import successVideo from '../../assets/video/paperplane.mp4';
import crossVideo from '../../assets/video/cross.mp4';
import { Dialog } from "primereact/dialog";
const Addbrandbook = () => {
  const { accessToken } = useAuth();
  const [isLoading, setIsLoading] = useState(false); // Add loading state
  const [videoDialogVisible, setVideoDialogVisible] = useState(false); // New state for video dialog
  const [videocrossDialogVisible, setVideocrossDialogVisible] = useState(false); // New state for video dialog
  const [brands, setBrands] = useState([]);
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);


  // State for Brand Managers (Social Media Managers)
  const [brandManagers, setBrandManagers] = useState([]);

  // State for Brand Associates (Other Selected Types)
  const [brandAssociates, setBrandAssociates] = useState([]);
  const [selectedAssociates, setSelectedAssociates] = useState([]);

  const handleSelect = (selectedUsers, type) => {
    setSelectedAssociates(prev => {
      const otherTypes = prev.filter(user => user.Associate_type !== type);

      const newUsers = selectedUsers.map(user => ({
        id: user.id,
        name: user.name,
        Associate_user_id: user.id,
        Associate_name: user.name,
        Associate_type: type,
      }));

      return [...otherTypes, ...newUsers];
    });
  };




  // Fetch brands from the API
  const fetchBrands = async () => {
    try {
      const response = await axios.get(`${config.apiBASEURL}/projectRoutes/fetchallbrands`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setBrands(response.data || []);
    } catch (error) {
      console.error("Error fetching brands:", error);
    }
  };
  useEffect(() => {
    fetchBrands();
  }, [accessToken]);

  // Filter brands for autocomplete
  const searchBrands = (event) => {
    const query = event.query.toLowerCase();
    setFilteredBrands(
      brands.filter((brand) =>
        brand.brand_name.toLowerCase().includes(query)
      )
    );
  };


  // Fetch Brand Managers (Social Media Managers)
  useEffect(() => {
    const fetchBrandManagers = async () => {
      try {
        const response = await fetch(`${config.apiBASEURL}/BrandBookRoutes/users/social-media-managers`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        const data = await response.json();
        if (response.ok) {
          const formattedData = data.map(user => ({
            id: user.user_id,  // Store correct user ID
            name: `${user.first_name} ${user.last_name}`, // Ensure name is correct
            Associate_user_id: user.user_id,  // Ensure correct mapping for API
            Associate_name: `${user.first_name} ${user.last_name}`,
            Associate_type: "Brand Manager",
          }));
          setBrandManagers(formattedData);
        }
      } catch (error) {
        console.error("Error fetching Brand Managers:", error);
      }
    };

    fetchBrandManagers();
  }, [accessToken]);


  // Fetch Brand Associates (Department_Head, Employee, Task_manager)
  useEffect(() => {
    const fetchBrandAssociates = async () => {
      try {
        const response = await fetch(`${config.apiBASEURL}/BrandBookRoutes/users/selected-types`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        const data = await response.json();
        if (response.ok) {
          const formattedData = data.map(user => ({
            id: user.user_id,  // Store correct user ID
            name: `${user.first_name} ${user.last_name}`, // Ensure name is correct
            Associate_user_id: user.user_id,  // Ensure correct mapping for API
            Associate_name: `${user.first_name} ${user.last_name}`,
            Associate_type: "Brand Associate",
          }));
          setBrandAssociates(formattedData);
        }
      } catch (error) {
        console.error("Error fetching Brand Associates:", error);
      }
    };

    fetchBrandAssociates();
  }, [accessToken]);


  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 9;

  const stepLabels = [
    "Brand Overview",
    "Brand Identity",
    "Target Audience",
    "Social Media Strategy",
    "Visual & Creative Guidelines",
    "Influencer & Community Engagement",
    "Advertising & Performance Tracking",
    "Campaign Planning & Execution",
    "Additional Notes & Resources",
  ];

  const handleNext = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrevious = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };



  useEffect(() => {
    const activeStepElement = document.querySelector('.steps__item--active');
    if (activeStepElement) {
      activeStepElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [currentStep]);

  const navigate = useNavigate();




  const [brandOverview, setBrandOverview] = useState({
    brand_name: "",
    tagline: "",
    industry: "",
    category: "",
    brandStory: "",
    missionStatement: "",
    visionStatement: "",
    coreValues: "",
    keyDifferentiators: "",
    competitorBrands: "",
  });

  const [brandIdentity, setBrandIdentity] = useState({
    brand_personality: [],
    tone_of_voice: [],
    primary_colors: '',
    secondary_colors: '',
    fonts: '',
    typography: '',
    logo_usage_guidelines: ''
  });

  const [showOtherInputs, setShowOtherInputs] = useState({
    brand_personality: false,
    tone_of_voice: false,
  });


  const [targetAudience, setTargetAudience] = useState({
    primary_age_group: "",
    primary_gender: "",
    primary_location: "",
    primary_interests_hobbies: "",
    primary_lifestyle_spending: "",
    primary_pain_points: "",
    secondary_target_audience: "",
  });


  const [SocialMediaStrategy, setSocialMediaStrategy] = useState({
    primaryGoals: [],
    social_media_platforms: '',
    posting_frequency: '',
    best_performing_content_types: '',
    content_pillars: '',
    hashtags_branded: '',
    cta_guidelines: '',
    crisis_management_plan: ''
  });

  const [showOtherGoalInput, setShowOtherGoalInput] = useState(false);
  const [otherGoalValue, setOtherGoalValue] = useState(''); // Stores the "Other" input value

  const [visualGuidelines, setVisualGuidelines] = useState({
    contentAesthetic: "",
    photographyVideographyGuidelines: "",
    graphicDesignStyle: "",
    dosAndDonts: "",
    templateDriveLink: "",
  });


  const [influencerEngagement, setInfluencerEngagement] = useState({
    influencerCollaborationGuidelines: "",
    ugcStrategy: "",
    brandAmbassadors: "",
    engagementStrategy: "",
    responseTimeExpectations: "",
  });

  const [advertisingPerformance, setAdvertisingPerformance] = useState({
    ad_platforms_used: "",
    monthly_budget: "",
    quarterly_budget: "",
    best_performing_ads: "",
    engagement_rate: "",
    follower_growth: "",
    conversion_rate: "",
    reach_impressions: "",
    other_metrics: "",
    tracking_reporting_tools: "",
    competitor_benchmarking: "",
  });

  const [campaignPlanning, setCampaignPlanning] = useState({
    annual_seasonal_campaigns: "",
    campaign_timeline_template: "",
    key_stakeholders_approval: "",
    campaign_evaluation_metrics: "",
  });


  const [AdditionalNotesResources, setAdditionalNotesResources] = useState({
    approval_hierarchy: "",
    important_docs_links: "",
    additional_guidelines: "",
  });




  // Handle change for all inputs dynamically
  const handlebrandOverviewChange = (e) => {
    const { name, value } = e.target;
    setBrandOverview((prevData) => ({
      ...prevData,
      [name]: value, // Update the specific field
    }));
  };


  const handleCheckboxChange = (e, category) => {
    const { value, checked } = e.target;

    setBrandIdentity((prevData) => {
      if (value === "Other") {
        setShowOtherInputs((prev) => ({
          ...prev,
          [category]: checked, // Toggle based on checked value
        }));

        return {
          ...prevData,
          [category]: checked
            ? [...prevData[category], { Other: "" }] // Add empty object for input
            : prevData[category].filter((item) => typeof item !== "object"), // Remove "Other"
        };
      }

      return {
        ...prevData,
        [category]: checked
          ? [...prevData[category], value]
          : prevData[category].filter((item) => item !== value),
      };
    });
  };


  const handleOtherInputChange = (e, category) => {
    const { value } = e.target;

    setBrandIdentity((prevData) => ({
      ...prevData,
      [category]: prevData[category].map((item) =>
        typeof item === "object" ? { Other: value } : item
      ),
    }));
  };



  const handleBrandIdentityChange = (e) => {
    const { name, value } = e.target;
    setBrandIdentity((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };




  // Handle input changes dynamically
  const handlevisualGuidelinesChange = (e) => {
    const { name, value } = e.target;
    setVisualGuidelines((prevData) => ({
      ...prevData,
      [name]: value, // Update the specific field
    }));
  };



  const updateCheckboxSelection = (e, customKey) => {
    const { value, checked } = e.target;

    setSocialMediaStrategy(prev => {
      let updatedGoals = [...prev.primaryGoals];

      if (customKey === 'otherGoal') {
        setShowOtherGoalInput(checked);
        if (checked) {
          updatedGoals.push({ Other: otherGoalValue || '' });
        } else {
          updatedGoals = updatedGoals.filter(goal => typeof goal !== 'object' || !goal.Other);
          setOtherGoalValue('');
        }
      } else {
        updatedGoals = checked
          ? [...updatedGoals, value]
          : updatedGoals.filter(goal => goal !== value);
      }

      return { ...prev, primaryGoals: updatedGoals };
    });
  };

  const handleOtherGoalInput = (e) => {
    const { value } = e.target;
    setOtherGoalValue(value);

    setSocialMediaStrategy(prev => ({
      ...prev,
      primaryGoals: prev.primaryGoals.map(goal =>
        typeof goal === 'object' && goal.Other !== undefined ? { Other: value } : goal
      )
    }));
  };

  const handleInputUpdate = (e) => {
    const { name, value } = e.target;
    setSocialMediaStrategy(prev => ({
      ...prev,
      [name]: value
    }));
  };
  // Handle input changes dynamically
  const handletargetAudienceChange = (e) => {
    const { name, value } = e.target;
    setTargetAudience((prevData) => ({
      ...prevData,
      [name]: value, // Update the specific field
    }));
  };


  const handleInfluencerEngagementChange = (e) => {
    const { name, value } = e.target;
    setInfluencerEngagement((prevData) => ({
      ...prevData,
      [name]: value, // Update the specific field
    }));
  };

  // Handle input changes dynamically
  const handleadvertisingPerformanceChange = (e) => {
    const { name, value } = e.target;
    setAdvertisingPerformance((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle input changes dynamically
  const handleCampaignPlanningChange = (e) => {
    const { name, value } = e.target;
    setCampaignPlanning((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle input changes dynamically
  const handleAdditionalNotesResourcesChange = (e) => {
    const { name, value } = e.target;
    setAdditionalNotesResources((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };



  const handleSave = async () => {
    if (!selectedBrand || !selectedAssociates || selectedAssociates.length === 0) {
      return; // Prevent submission if brand or associates are missing
    }  

    const brandData = {
      brand_id: selectedBrand.brand_id,
      brandAssociates: selectedAssociates,
      additionalNotes: AdditionalNotesResources,
      campaignPlanning,
      advertisingPerformance,
      influencerEngagement,
      visualGuidelines,
      socialMediaStrategy: SocialMediaStrategy,
      targetAudience,
      brandIdentity,
      brandOverview
    };

    try {
      setIsLoading(true); // Set loading state
      const response = await axios.post(`${config.apiBASEURL}/BrandBookRoutes/add-brand-data`, brandData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      );

      if (response.data.success) {
        // Fetch updated taskboard data

        setIsLoading(false); // Stop loading
        setVideoDialogVisible(true); // Show video dialog
        setTimeout(() => {
          setVideoDialogVisible(false); // Hide video dialog after 6 seconds
          navigate('/Graphe/dashboard/brandfile'); // Navigate to the brandbook page
        }, 5000);

      }
    } catch (error) {
      console.error("Error saving brand data:", error);
      setIsLoading(false); // Stop loading
      setVideocrossDialogVisible(true); // Show video dialog

      setTimeout(() => {
        setVideocrossDialogVisible(false); // Hide video dialog after 6 seconds

      }, 5000);

    }
  };








  return (
    <>
      <Row className="body_content">
        <Row className="mx-0">
          <Col md={6} lg={6} className="mb-4">
            <Breadcrumb>
              <Breadcrumb.Item onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
                <i className="pi pi-angle-left"></i> Back
              </Breadcrumb.Item>
              <Breadcrumb.Item active>Add Brand Book</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          <Col md={12} lg={12}>
            <Card>
              <Card.Body>
                <Row>
                  <Col md={5} lg={4} className="pe-0">
                    <ul className="steps steps--vertical sticky-top">
                      {stepLabels.map((label, index) => (
                        <li
                          key={index}
                          className={`steps__item ${index + 1 < currentStep ? "steps__item--complete" : ""
                            } ${index + 1 === currentStep ? "steps__item--active steps__item--highlight" : ""}`}
                        >
                          <div className="steps__label">{label}</div>
                          <div className="steps__space"></div>
                        </li>
                      ))}
                    </ul>
                  </Col>

                  <Col md={7} lg={8} className="p-0">
                    {[...Array(totalSteps)].map((_, index) => (
                      <Card
                        key={index}
                        className={`shadow-0 p-0 mb-3 ${currentStep === index + 1 ? "d-block" : "d-none"
                          }`}
                      >
                        <CardHeader className="pt-0 ps-0 pe-0 h6">
                          {stepLabels[index]}
                        </CardHeader>
                        <CardBody className="pb-0 ps-0 pe-0">
                          <Form>
                            {index + 1 === 1 && (
                              <>
                                <Row>
                                  <Col md={6} lg={6} className="mb-3 px-1">
                                    <Form.Label>Brand Name</Form.Label>
                                    <AutoComplete
                                      value={selectedBrand}
                                      suggestions={filteredBrands}
                                      completeMethod={searchBrands}
                                      field="brand_name"
                                      onChange={(e) => {
                                        setSelectedBrand(e.value);
                                        setBrandOverview((prev) => ({
                                          ...prev,
                                          brand_name: e.value.brand_name, // Ensure the brand_name is updated
                                        }));
                                      }}
                                      placeholder="Search Brand"
                                      className="w-100"
                                    />

                                  </Col>
                                  <Col md={6} lg={6} className="mb-3 px-1">
                                    <Form.Label>Tagline/Slogan</Form.Label>
                                    <Form.Control type="text" name="tagline" value={brandOverview.tagline} onChange={handlebrandOverviewChange} />
                                  </Col>
                                  <Col md={6} lg={6} className="mb-3 px-1">
                                    <Form.Label>Industry </Form.Label>
                                    <Form.Control type="text" name="industry" value={brandOverview.industry} onChange={handlebrandOverviewChange} />
                                  </Col>
                                  <Col md={6} lg={6} className="mb-3 px-1">
                                    <Form.Label>Category </Form.Label>
                                    <Form.Control type="text" name="category" value={brandOverview.category} onChange={handlebrandOverviewChange} />
                                  </Col>
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Brand Story <sub>(Short Summary)</sub></Form.Label>
                                    <Form.Control as="textarea" className="h-auto" rows={3} name="brandStory" value={brandOverview.brandStory} onChange={handlebrandOverviewChange} />
                                  </Col>
                                  <Col md={6} lg={6} className="mb-3 px-1">
                                    <Form.Label>Mission Statement</Form.Label>
                                    <Form.Control as="textarea" className="h-auto" rows={3} name="missionStatement" value={brandOverview.missionStatement} onChange={handlebrandOverviewChange} />
                                  </Col>
                                  <Col md={6} lg={6} className="mb-3 px-1">
                                    <Form.Label>Vision Statement</Form.Label>
                                    <Form.Control as="textarea" className="h-auto" rows={3} name="visionStatement" value={brandOverview.visionStatement} onChange={handlebrandOverviewChange} />
                                  </Col>
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Core Values</Form.Label>
                                    <Form.Control as="textarea" className="h-auto" rows={5} name="coreValues" value={brandOverview.coreValues} onChange={handlebrandOverviewChange} />
                                  </Col>
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Key Differentiators <sub>(What makes this brand unique?)</sub></Form.Label>
                                    <Form.Control as="textarea" className="h-auto" rows={3} name="keyDifferentiators" value={brandOverview.keyDifferentiators} onChange={handlebrandOverviewChange} />
                                  </Col>
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Competitor Brands</Form.Label>
                                    <Form.Control as="textarea" className="h-auto" rows={3} name="competitorBrands" value={brandOverview.competitorBrands} onChange={handlebrandOverviewChange} />
                                  </Col>
                                </Row>
                              </>
                            )}
                            {index + 1 === 2 && (
                              <>
                                <Row>
                                  <Col md={6} lg={6} className="mb-4 pe-lg-5 border-end">
                                    <Form.Label>Brand Personality <sub>(Select any that apply or add more)</sub></Form.Label>
                                    <div className="d-flex flex-wrap gap-4 justify-content-between mt-1 pt-4 border-top">
                                      {["Playful", "Professional", "Luxurious", "Minimalist", "Bold", "Quirky", "Traditional"].map((item, index) => (
                                        <div key={index} className="d-flex align-items-center fixed_checkbox">
                                          <Checkbox
                                            inputId={`personality-${index}`}
                                            value={item}
                                            onChange={(e) => handleCheckboxChange(e, "brand_personality")}
                                            checked={brandIdentity.brand_personality.includes(item)}
                                          />
                                          <label htmlFor={`personality-${index}`} className="ms-2">
                                            {item}
                                          </label>
                                        </div>

                                      ))}
                                      <div className="d-flex align-items-center fixed_checkbox">
                                        <Checkbox
                                          inputId="personality-other"
                                          value="Other"
                                          onChange={(e) => handleCheckboxChange(e, "brand_personality")}
                                          checked={showOtherInputs.brand_personality}
                                        />

                                        <label htmlFor="personality-other" className="ms-2">Other</label>
                                      </div>
                                      {showOtherInputs.brand_personality && (
                                        <div className="w-100">
                                          <Form.Control type="text" placeholder="Enter other" onChange={(e) => handleOtherInputChange(e, "brand_personality")} />
                                        </div>
                                      )}
                                    </div>
                                  </Col>
                                  <Col md={6} lg={6} className="mb-4 ps-lg-5">
                                    <Form.Label>Tone of Voice  <sub>(How should the brand sound?)</sub></Form.Label>
                                    <div className="d-flex flex-wrap gap-4 justify-content-between mt-1 pt-4 border-top">
                                      {["Formal", "Friendly", "Authoritative", "Conversational", "Witty", "Inspirational"].map((item, index) => (
                                        <div key={index} className="d-flex align-items-center fixed_checkbox">
                                          <Checkbox
                                            inputId={`tone-${index}`}
                                            value={item}
                                            onChange={(e) => handleCheckboxChange(e, "tone_of_voice")}
                                            checked={brandIdentity.tone_of_voice.includes(item)}
                                          />
                                          <label htmlFor={`tone-${index}`} className="ms-2">
                                            {item}
                                          </label>
                                        </div>
                                      ))}
                                      <div className="d-flex align-items-center fixed_checkbox">

                                        <Checkbox
                                          inputId="tone-other"
                                          value="Other"
                                          onChange={(e) => handleCheckboxChange(e, "tone_of_voice")}
                                          checked={showOtherInputs.tone_of_voice}
                                        />

                                        <label htmlFor="tone-other" className="ms-2">Other</label>
                                      </div>
                                      {showOtherInputs.tone_of_voice && (
                                        <div className="w-100">
                                          <Form.Control type="text" placeholder="Enter other" onChange={(e) => handleOtherInputChange(e, "tone_of_voice")} />
                                        </div>
                                      )}
                                    </div>
                                  </Col>
                                  <Col md={6} lg={6} className="mb-3 px-1">
                                    <Form.Label>Primary Color</Form.Label>
                                    <Form.Control as="textarea" className="h-auto" rows={3} name="primary_colors" value={brandIdentity.primary_colors} onChange={handleBrandIdentityChange} />
                                  </Col>
                                  <Col md={6} lg={6} className="mb-3 px-1">
                                    <Form.Label>Secondary Color</Form.Label>
                                    <Form.Control as="textarea" className="h-auto" rows={3} name="secondary_colors" value={brandIdentity.secondary_colors} onChange={handleBrandIdentityChange} />
                                  </Col>
                                  <Col md={6} lg={6} className="mb-3 px-1">
                                    <Form.Label>Fonts</Form.Label>
                                    <Form.Control as="textarea" className="h-auto" rows={3} name="fonts" value={brandIdentity.fonts} onChange={handleBrandIdentityChange} />
                                  </Col>
                                  <Col md={6} lg={6} className="mb-3 px-1">
                                    <Form.Label>Typography</Form.Label>
                                    <Form.Control as="textarea" className="h-auto" rows={3} name="typography" value={brandIdentity.typography} onChange={handleBrandIdentityChange} />
                                  </Col>
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Logo Usage Guidelines</Form.Label>
                                    <Form.Control as="textarea" name="logo_usage_guidelines" rows={5} className="h-auto" value={brandIdentity.logo_usage_guidelines} onChange={handleBrandIdentityChange} />
                                  </Col>
                                </Row>
                              </>
                            )}
                            {index + 1 === 3 && (
                              <>
                                <Row>
                                  <Col md={6} lg={6} className="mb-3 px-1">
                                    <Form.Label>Age Group</Form.Label>
                                    <Form.Control type="text" name="primary_age_group" value={targetAudience.primary_age_group} onChange={handletargetAudienceChange} />
                                  </Col>

                                  <Col md={6} lg={6} className="mb-3 px-1">
                                    <Form.Label>Gender</Form.Label>
                                    <Form.Control type="text" name="primary_gender" value={targetAudience.primary_gender} onChange={handletargetAudienceChange} />
                                  </Col>

                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Location</Form.Label>
                                    <Form.Control as="textarea" name="primary_location" value={targetAudience.primary_location} onChange={handletargetAudienceChange} rows={2} className="h-auto"/>
                                  </Col>

                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Interests & Hobbies</Form.Label>
                                    <Form.Control as="textarea" name="primary_interests_hobbies" value={targetAudience.primary_interests_hobbies} onChange={handletargetAudienceChange} rows={2} className="h-auto" />
                                  </Col>

                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Lifestyle & Spending Habits</Form.Label>
                                    <Form.Control as="textarea" name="primary_lifestyle_spending" value={targetAudience.primary_lifestyle_spending} onChange={handletargetAudienceChange} rows={2} className="h-auto" />
                                  </Col>

                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Pain Points & Problems the Brand Solves</Form.Label>
                                    <Form.Control as="textarea" name="primary_pain_points" value={targetAudience.primary_pain_points} onChange={handletargetAudienceChange} rows={2} className="h-auto" />
                                  </Col>

                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Secondary Target Audience</Form.Label>
                                    <Form.Control as="textarea" name="secondary_target_audience" value={targetAudience.secondary_target_audience} onChange={handletargetAudienceChange} rows={5} className="h-auto" />
                                  </Col>
                                </Row>
                              </>
                            )}
                            {index + 1 === 4 && (
                              <>
                                <Row>
                                  <Col md={12} lg={12} className="mb-4 pe-lg-5">
                                    <Form.Label>Primary Goals for Social Media</Form.Label>
                                    <div className="d-flex flex-wrap gap-4 mt-1 pt-4 border-top">
                                      {['Brand Awareness', 'Engagement', 'Lead Generation', 'Sales Conversion', 'Community Building', 'Customer Support', 'Thought Leadership'].map(goal => (
                                        <div key={goal} className="d-flex align-items-center">
                                          <Checkbox inputId={goal} value={goal} onChange={updateCheckboxSelection} checked={SocialMediaStrategy.primaryGoals.some(g => g === goal)} />
                                          <label htmlFor={goal} className="ms-2">{goal}</label>
                                        </div>
                                      ))}
                                      <div className="d-flex align-items-center">
                                        <Checkbox inputId="OtherGoal" value="Other" onChange={(e) => updateCheckboxSelection(e, 'otherGoal')} checked={SocialMediaStrategy.primaryGoals.some(g => typeof g === 'object' && g.Other !== undefined)} />
                                        <label htmlFor="OtherGoal" className="ms-2">Other</label>
                                      </div>
                                      {showOtherGoalInput && (
                                        <div className="w-100">
                                          <Form.Control type="text" placeholder="Enter other goal" name="otherGoal" value={otherGoalValue} onChange={handleOtherGoalInput} autoFocus />
                                        </div>
                                      )}
                                    </div>
                                  </Col>
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Key Social Media Platforms & Handles</Form.Label>
                                    <Form.Control as="textarea" name="social_media_platforms" value={SocialMediaStrategy.social_media_platforms} onChange={handleInputUpdate} rows={3} className="h-auto" />
                                  </Col>
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Posting Frequency <sub>(Per Platform)</sub></Form.Label>
                                    <Form.Control as="textarea" name="posting_frequency" value={SocialMediaStrategy.posting_frequency} onChange={handleInputUpdate} rows={3} className="h-auto" />
                                  </Col>
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Best-Performing Content Types <sub>(E.g., Reels, Carousels, Infographics, Memes, Stories, Polls, UGC, etc.)</sub></Form.Label>
                                    <Form.Control as="textarea" name="best_performing_content_types" value={SocialMediaStrategy.best_performing_content_types} onChange={handleInputUpdate} rows={3} className="h-auto" />

                                  </Col>
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Content Pillars <sub>(Define the main themes of content, e.g., Education, Inspiration, Promotion, Community, etc.)</sub></Form.Label>
                                    <Form.Control as="textarea" name="content_pillars" value={SocialMediaStrategy.content_pillars} onChange={handleInputUpdate} rows={5} className="h-auto" />
                                  </Col>
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Hashtags Strategy</Form.Label>
                                    <Form.Control as="textarea" name="hashtags_branded" value={SocialMediaStrategy.hashtags_branded} onChange={handleInputUpdate} rows={3} className="h-auto" />
                                  </Col>
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>CTA  Guidelines <sub>(Call-To-Action)</sub></Form.Label>
                                    <Form.Control as="textarea" name="cta_guidelines" value={SocialMediaStrategy.cta_guidelines} onChange={handleInputUpdate} rows={3} className="h-auto" />
                                  </Col>
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Crisis Management Plan <sub>(How to handle PR issues or negative feedback online)</sub></Form.Label>
                                    <Form.Control as="textarea" name="crisis_management_plan" value={SocialMediaStrategy.crisis_management_plan} onChange={handleInputUpdate} rows={5} className="h-auto" />
                                  </Col>
                                </Row>
                              </>
                            )}
                            {index + 1 === 5 && (
                              <>
                                <Row>
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Content Aesthetic <sub>(Describe the look & feel of visuals)</sub></Form.Label>
                                    <Form.Control as="textarea" name="contentAesthetic" value={visualGuidelines.contentAesthetic} onChange={handlevisualGuidelinesChange} rows={3} className="h-auto" />
                                  </Col>

                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Photography & Videography Guidelines <sub>(Filters, angles, tone, etc.)</sub></Form.Label>
                                    <Form.Control as="textarea" name="photographyVideographyGuidelines" value={visualGuidelines.photographyVideographyGuidelines} onChange={handlevisualGuidelinesChange} rows={3} className="h-auto" />
                                  </Col>

                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Graphic Design Style <sub>(Minimal, Illustrative, Bold, etc.)</sub></Form.Label>
                                    <Form.Control as="textarea" name="graphicDesignStyle" value={visualGuidelines.graphicDesignStyle} onChange={handlevisualGuidelinesChange} rows={3} className="h-auto" />
                                  </Col>

                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Do's & Don'ts for Creatives</Form.Label>
                                    <Form.Control as="textarea" name="dosAndDonts" value={visualGuidelines.dosAndDonts} onChange={handlevisualGuidelinesChange} rows={3} className="h-auto" />
                                  </Col>

                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Templates & Editable Design Files <sub>(Link to drive folder)</sub></Form.Label>
                                    <Form.Control as="textarea" name="templateDriveLink" value={visualGuidelines.templateDriveLink} onChange={handlevisualGuidelinesChange} rows={3} className="h-auto" />
                                  </Col>
                                </Row>
                              </>
                            )}
                            {index + 1 === 6 && (
                              <>
                                <Row>
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Influencer Collaboration Guidelines</Form.Label>
                                    <Form.Control as="textarea" name="influencerCollaborationGuidelines" value={influencerEngagement.influencerCollaborationGuidelines} onChange={handleInfluencerEngagementChange} rows={3} className="h-auto" />
                                  </Col>

                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>UGC Strategy <sub>(User-Generated Content)</sub></Form.Label>
                                    <Form.Control as="textarea" name="ugcStrategy" value={influencerEngagement.ugcStrategy} onChange={handleInfluencerEngagementChange} rows={3} className="h-auto" />
                                  </Col>

                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Brand Ambassadors or Key Advocates</Form.Label>
                                    <Form.Control as="textarea" name="brandAmbassadors" value={influencerEngagement.brandAmbassadors} onChange={handleInfluencerEngagementChange} rows={3} className="h-auto" />
                                  </Col>

                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Engagement Strategy <sub>(Replying to comments, DMs, brand interactions)</sub></Form.Label>
                                    <Form.Control as="textarea" name="engagementStrategy" value={influencerEngagement.engagementStrategy} onChange={handleInfluencerEngagementChange} rows={5} className="h-auto" />
                                  </Col>

                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Response Time Expectations</Form.Label>
                                    <Form.Control as="textarea" name="responseTimeExpectations" value={influencerEngagement.responseTimeExpectations} onChange={handleInfluencerEngagementChange} rows={3} className="h-auto" />
                                  </Col>
                                </Row>
                              </>
                            )}
                            {index + 1 === 7 && (
                              <>
                                <Row>
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Ad Platforms Used</Form.Label>
                                    <Form.Control as="textarea" name="ad_platforms_used" value={advertisingPerformance.ad_platforms_used} onChange={handleadvertisingPerformanceChange} rows={2} className="h-auto"/>
                                  </Col>

                                  {/* Ad Budget Allocation Section */}
                                  <Col md={12} lg={12} className="mb-3 px-1 h6">Ad Budget Allocation</Col>

                                  <Col md={6} lg={6} className="mb-3 px-1">
                                    <Form.Label>Monthly</Form.Label>
                                    <Form.Control type="text" name="monthlyBmonthly_budgetudget" value={advertisingPerformance.monthly_budget} onChange={handleadvertisingPerformanceChange} />
                                  </Col>

                                  <Col md={6} lg={6} className="mb-3 px-1">
                                    <Form.Label>Quarterly</Form.Label>
                                    <Form.Control type="text" name="quarterly_budget" value={advertisingPerformance.quarterly_budget} onChange={handleadvertisingPerformanceChange} />
                                  </Col>

                                  {/* Best Performing Ads */}
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Best-Performing Ads & Learnings</Form.Label>
                                    <Form.Control as="textarea" name="best_performing_ads" value={advertisingPerformance.best_performing_ads} onChange={handleadvertisingPerformanceChange} rows={3} className="h-auto" />
                                  </Col>

                                  {/* KPIs & Metrics Section */}
                                  <Col md={12} lg={12} className="mb-3 px-1 h6">KPIs & Metrics Tracked</Col>

                                  <Col md={6} lg={6} className="mb-3 px-1">
                                    <Form.Label>Engagement Rate</Form.Label>
                                    <Form.Control type="text" name="engagement_rate" value={advertisingPerformance.engagement_rate} onChange={handleadvertisingPerformanceChange} />
                                  </Col>

                                  <Col md={6} lg={6} className="mb-3 px-1">
                                    <Form.Label>Follower Growth</Form.Label>
                                    <Form.Control type="text" name="follower_growth" value={advertisingPerformance.follower_growth} onChange={handleadvertisingPerformanceChange} />
                                  </Col>

                                  <Col md={6} lg={6} className="mb-3 px-1">
                                    <Form.Label>Conversion Rate</Form.Label>
                                    <Form.Control type="text" name="conversion_rate" value={advertisingPerformance.conversion_rate} onChange={handleadvertisingPerformanceChange} />
                                  </Col>

                                  <Col md={6} lg={6} className="mb-3 px-1">
                                    <Form.Label>Reach & Impressions</Form.Label>
                                    <Form.Control type="text" name="reach_impressions" value={advertisingPerformance.reach_impressions} onChange={handleadvertisingPerformanceChange} />
                                  </Col>

                                  <Col md={6} lg={6} className="mb-3 px-1">
                                    <Form.Label>Other</Form.Label>
                                    <Form.Control type="text" name="other_metrics" value={advertisingPerformance.other_metrics} onChange={handleadvertisingPerformanceChange} />
                                  </Col>

                                  {/* Tracking & Reporting Tools */}
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Tracking & Reporting Tools Used</Form.Label>
                                    <Form.Control as="textarea" name="tracking_reporting_tools" value={advertisingPerformance.tracking_reporting_tools} onChange={handleadvertisingPerformanceChange} rows={2} className="h-auto" />
                                  </Col>

                                  {/* Competitor Benchmarking */}
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Competitor Benchmarking Insights</Form.Label>
                                    <Form.Control as="textarea" name="competitor_benchmarking" value={advertisingPerformance.competitor_benchmarking} onChange={handleadvertisingPerformanceChange} rows={2} className="h-auto" />
                                  </Col>
                                </Row>
                              </>
                            )}
                            {index + 1 === 8 && (
                              <>
                                <Row>
                                  {/* Annual & Seasonal Campaigns */}
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>
                                      Annual & Seasonal Campaigns <sub>(Festivals, Sales, Product Launches, etc.)</sub>
                                    </Form.Label>
                                    <Form.Control
                                      as="textarea"
                                      name="annual_seasonal_campaigns"
                                      value={campaignPlanning.annual_seasonal_campaigns}
                                      onChange={handleCampaignPlanningChange}
                                      rows={2}
                                      className="h-auto"
                                    />
                                  </Col>

                                  {/* Campaign Timeline Template */}
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Campaign Timeline Template</Form.Label>
                                    <Form.Control
                                      as="textarea"
                                      name="campaign_timeline_template"
                                      value={campaignPlanning.campaign_timeline_template}
                                      onChange={handleCampaignPlanningChange}
                                      rows={2}
                                      className="h-auto"
                                    />
                                  </Col>

                                  {/* Key Stakeholders & Approval Process */}
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Key Stakeholders & Approval Process</Form.Label>
                                    <Form.Control
                                      as="textarea"
                                      name="key_stakeholders_approval"
                                      value={campaignPlanning.key_stakeholders_approval}
                                      onChange={handleCampaignPlanningChange}
                                      rows={2}
                                      className="h-auto"
                                    />
                                  </Col>

                                  {/* Campaign Evaluation Metrics */}
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Campaign Evaluation Metrics</Form.Label>
                                    <Form.Control
                                      as="textarea"
                                      name="campaign_evaluation_metrics"
                                      value={campaignPlanning.campaign_evaluation_metrics}
                                      onChange={handleCampaignPlanningChange}
                                      rows={2}
                                      className="h-auto"
                                    />
                                  </Col>
                                </Row>
                              </>
                            )}
                            {index + 1 === 9 && (
                              <>
                                <Row>
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Brand Manager & Point of Contact</Form.Label>
                                    <MultiSelect
                                      value={selectedAssociates.filter(user => user.Associate_type === 'Brand Manager')}
                                      onChange={(e) => handleSelect(e.value, 'Brand Manager')}
                                      options={brandManagers}
                                      optionLabel="name"  // Make sure "name" is correctly mapped
                                      dataKey="id"  // Ensure unique identification for checked status
                                      filter
                                      placeholder="Select Brand Managers"
                                      maxSelectedLabels={3}
                                      display="chip"
                                    />
                                  </Col>

                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Brand Associate</Form.Label>
                                    <MultiSelect
                                      value={selectedAssociates.filter(user => user.Associate_type === 'Brand Associate')}
                                      onChange={(e) => handleSelect(e.value, 'Brand Associate')}
                                      options={brandAssociates}
                                      optionLabel="name"
                                      dataKey="id"  // Ensures correct checkboxes and selection
                                      filter
                                      placeholder="Select Brand Associates"
                                      maxSelectedLabels={3}
                                      display="chip"
                                    />
                                  </Col>


                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Approval Hierarchy for Content & Ads</Form.Label>
                                    <Form.Control
                                      as="textarea"
                                      name="approval_hierarchy"
                                      value={AdditionalNotesResources.approval_hierarchy}
                                      onChange={handleAdditionalNotesResourcesChange}
                                      rows={2}
                                      className="h-auto"
                                    />
                                  </Col>

                                  {/* Links to Important Docs */}
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>
                                      Links to Important Docs <sub>(Drive folders, previous reports, brand assets, etc.)</sub>
                                    </Form.Label>
                                    <Form.Control
                                      as="textarea"
                                      name="important_docs_links"
                                      value={AdditionalNotesResources.important_docs_links}
                                      onChange={handleAdditionalNotesResourcesChange}
                                      rows={2}
                                      className="h-auto"
                                    />
                                  </Col>

                                  {/* Additional Guidelines or Notes */}
                                  <Col md={12} lg={12} className="mb-3 px-1">
                                    <Form.Label>Additional Guidelines or Notes</Form.Label>
                                    <Form.Control
                                      as="textarea"
                                      name="additional_guidelines"
                                      value={AdditionalNotesResources.additional_guidelines}
                                      onChange={handleAdditionalNotesResourcesChange}
                                      rows={2}
                                      className="h-auto"
                                    />
                                  </Col>
                                  {/* <Col md={6} lg={6} className="mb-3 px-1">
                                    <Form.Label>Last Updated On</Form.Label>
                                    <Calendar value={date} onChange={(e) => setDate(e.value)} />
                                  </Col> */}
                                </Row>
                              </>
                            )}
                          </Form>
                        </CardBody>
                        <CardFooter className="border-0 pb-0 ps-0 pe-0">
                          <div className="d-flex justify-content-between mt-3">
                            <Button
                              label='Previous'
                              severity="secondary"
                              icon="pi pi-arrow-left"
                              className="py-2"
                              onClick={handlePrevious}
                              disabled={currentStep === 1}
                            />
                            {currentStep < totalSteps ? (
                              <Button
                                label='Next'
                                icon="pi pi-arrow-right"
                                iconPos="right"
                                className="py-2"
                                severity="info"
                                onClick={handleNext}
                              />
                            ) : (
                              <Button
                                label={isLoading ? 'Saving...' : 'Save'}
                                icon={isLoading ? 'pi pi-spin pi-spinner' : 'pi pi-folder-open'}
                                className="py-2"
                                severity="success"
                                onClick={handleSave}
                                disabled={isLoading}
                              />

                            )}
                          </div>
                        </CardFooter>
                      </Card>
                    ))}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Row>

      <Dialog visible={videoDialogVisible} className='fadeInUp_dilog'
        onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
        <video src={successVideo} autoPlay loop muted style={{ width: '100%' }} />
        <h6 className="text-center mt-0 fadeInUp">Process Completed <span className='text-success'>Successfully</span></h6>
      </Dialog>


      <Dialog visible={videocrossDialogVisible} className='fadeInUp_dilog'
        onHide={() => setVideocrossDialogVisible(false)} style={{ width: '320px' }} closable={false}>
        <video src={crossVideo} autoPlay loop muted style={{ width: '100%' }} />
        <h6 className="text-center mt-0 fadeInUp">Process <span className='text-danger'>Denied</span></h6>
      </Dialog>



    </>
  );
};

export default Addbrandbook;
